export const VIP_SUPPORT = {
    FLAT_HOUSING_POLICY: 'https://help.gumtree.com/s/policies?cat=Category_Specific_Policies&article=Property-Policies',
    FRAUD_SUPPORT: 'https://help.gumtree.com/s/login/?startURL=%2Farticles%2FGeneral_Information%2FReporting-issues-to-Gumtree%3Fat%3DHow%2Bdo%2BI%2Breport%2Bsomething%2Bto%2Byou%253F%26c%3DAll'
}
